// extracted by mini-css-extract-plugin
export var editButton = "_kn-0";